function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63 0C97.7939 0 126 28.2061 126 63C126 97.7939 97.7939 126 63 126C28.2061 126 0 97.7939 0 63C0 28.2061 28.2061 0 63 0Z",
  fill: "url(#paint0_linear_1194_291)"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63 119C93.9279 119 119 93.9279 119 63C119 32.0721 93.9279 7 63 7C32.0721 7 7 32.0721 7 63C7 93.9279 32.0721 119 63 119Z",
  stroke: "white",
  strokeWidth: 1.4
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63 105C86.196 105 105 86.196 105 63C105 39.804 86.196 21 63 21C39.804 21 21 39.804 21 63C21 86.196 39.804 105 63 105Z",
  stroke: "white",
  strokeWidth: 1.4
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M108.282 44.2442C105.799 38.2551 102.162 32.8652 97.6482 28.3518C88.7809 19.4845 76.5309 14 63 14C49.469 14 37.219 19.4845 28.3517 28.3518C23.8383 32.8652 20.2012 38.2551 17.7178 44.2442",
  stroke: "white",
  strokeWidth: 15.4,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M63 14.0001V111.222",
  stroke: "white",
  strokeWidth: 15.4,
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1194_291",
  x1: 126,
  y1: 0,
  x2: 126,
  y2: 126,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2BDBC0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#13B58C"
})));
function SvgTradlyIconSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradlyIconSvg);
export default __webpack_public_path__ + "static/media/tradlyIconSVG.2eadfaf0.svg";
export { ForwardRef as ReactComponent };